export default __webpack_public_path__ + "static/17-578b4abcba399167b75c7dfd9d4477a6.webp";